



































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditSpecifique.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'
import { FluxRestrictFlag } from '@/enum/FluxRestrictFlag'

@Component({
  name: 'ReadSpecifique',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    }
  }
})
export default class ReadSpecifique extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean

  edit() { 
    (this.$refs.edit as Edit).edit(this.flux)
  }


}
